import React, { useEffect } from "react";
import HeroSection from "./HeroSection";
import ProductDetails from "./ProductDetails";
import Benefits from "./Benefits";
import FAQSection from "./FAQSection";

import img1 from "../assets/birdspikes/1.jpg";
import img2 from "../assets/birdspikes/2.jpg";
import img3 from "../assets/birdspikes/3.jpg";
import img4 from "../assets/birdspikes/4.jpg";
import img5 from "../assets/birdspikes/5.jpg";
import Images from "./Images";
import main from "../assets/birdspikes.jpg";
import { Helmet } from "react-helmet-async";

export default function BirdSpikes() {

       useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Anti bird spikes bird- spikes for roofs  installation Bengaluru S",
    url: "https://www.anssafetynets.com/birdspikes",
    description:
      "Bird Spikes – Effective Bird Control Solution Protect your property from unwanted birds with our high-quality bird spikes. Designed to prevent pigeons, seagulls, and other large birds from landing or roosting, these durable spikes offer a humane and long-lasting deterrent for ledges, roofs, signage, and more.",
    keywords: [
      "bird spikes",
      "anti bird spikes",
      "bird deterrent spikes",
      "pigeon spikes",
      "bird control spikes",
      "bird spikes for roof",
      "bird spikes for ledges",
      "stainless steel bird spikes",
      "plastic bird spikes",
      "bird spikes for signs",
      "best bird spikes for pigeons",
      "humane bird deterrent",
      "install bird spikes",
      "buy bird spikes online",
      "bird spikes near me",
      "bird spikes installation service",
      "bird spikes Bengaluru",
      "anti bird spikes Bangalore",
    ],
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.anssafetynets.com",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Bird Spikes",
          item: "https://www.anssafetynets.com/birdspikes",
        },
      ],
    },
    publisher: {
      "@type": "Organization",
      name: "ANS Safety Nets",
      logo: {
        "@type": "ImageObject",
        url: "https://www.anssafetynets.com/logo.png",
        width: 250,
        height: 100,
      },
      contactPoint: [
        {
          "@type": "ContactPoint",
          telephone: "+91-7416116587",
          contactType: "Customer Service",
          areaServed: "IN",
          availableLanguage: ["English", "Kannada"],
        },
      ],
      sameAs: [
        "https://www.facebook.com/profile.php?id=61572534324956",
        "https://www.instagram.com/anssafetynets_bengaluru/",
      ],
    },
    mainEntity: {
      "@type": "Organization",
      name: "ANS Safety Nets",
      address: {
        "@type": "PostalAddress",
        streetAddress:
          "74/9, 5th Cross Rd, Muthyala Nagar, Bahubali Nagar, Jalahalli, Bengaluru, Karnataka 560013",
        addressLocality: "Bengaluru",
        addressRegion: "KA",
        postalCode: "560013",
        addressCountry: "IN",
      },
      service: [
        {
          "@type": "Service",
          name: "Bird Spikes",
          areaServed: "Bengaluru",
        },
      ],
    },
  };

  return (
    <div>
      <Helmet>
        <title>
          Anti bird spikes bird- spikes for roofs  installation Bengaluru S
        </title>
        <meta
          name="description"
          content="Bird Spikes – Effective Bird Control Solution
Protect your property from unwanted birds with our high-quality bird spikes. Designed
to prevent pigeons, seagulls, and other large birds from landing or roosting, these
durable spikes offer a humane and long-lasting deterrent for ledges, roofs, signage, and
more."
        />
        <meta
          name="keywords"
          content="bird spikes
anti bird spikes
bird deterrent spikes
pigeon spikes
bird control spikes
bird spikes for roof
bird spikes for ledges
stainless steel bird spikes
plastic bird spikes
bird spikes for signs
best bird spikes for pigeons
humane bird deterrent
install bird spikes
buy bird spikes online
bird spikes near me
bird spikes installation service
Bird spikes Bengaluru 
Anti bird spikes bangalore"
        />
        <meta name="author" content="ANS Safety Nets, Bengaluru" />
        <link rel="canonical" href="https://www.anssafetynets.com/birdspikes" />
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      </Helmet>
      <HeroSection
        title="Bird Spikes"
        description="Prevent unwanted birds from perching with our effective bird spikes."
        bgColor="bg-[#37474f]"
        image="https://example.com/bird-spikes.jpg"
      />

      <ProductDetails
        title="Why Choose Our Bird Spikes?"
        content="At ANS Safety Nets, we understand the importance of protecting your property while maintaining a harmonious environment. Our bird spikes are expertly designed to deter birds from landing or nesting on your property, providing an effective yet humane solution. Made from high-quality, weather-resistant materials, our bird spikes ensure long-lasting protection without causing harm to the birds. In addition to bird control, we specialize in safety net services for a variety of needs, including balcony safety nets, anti-bird nets, construction safety nets, and sports nets. Whether you're looking to keep your property safe from birds, protect your family, or ensure worker safety on construction sites, ANS Safety Nets offers customized, reliable solutions that stand the test of time. Our goal is to provide you with peace of mind, knowing that your property is secure, safe, and free from unwanted pests."
        image={main}
      />
      <Images images={[img1, img2, img3, img4, img5]} />

      <Benefits
        benefits={[
          {
            title: "Bird Control",
            description:
              "Keep birds away from your property without causing harm.",
          },
          {
            title: "Durable",
            description:
              "Made from rust-resistant materials to last through all weather conditions.",
          },
          {
            title: "Easy Installation",
            description: "Simple to install on various surfaces.",
          },
        ]}
      />

      <FAQSection
        faqs={[
          {
            question: "Are the bird spikes safe for animals?",
            answer:
              "Yes, the spikes are designed to be harmless to both birds and other animals.",
          },
          {
            question: "Can I install these spikes myself?",
            answer:
              "Yes, the spikes come with easy-to-follow instructions for DIY installation.",
          },
        ]}
      />
    </div>
  );
}
